<div class="fixed inset-0 bg-black/80 flex items-center justify-center z-50">
  <div class="bg-white rounded-lg shadow-lg p-6 pt-8 w-[90%] max-w-lg relative">
    <button
      (click)="closeModal()"
      class="absolute top-3 right-3 text-gray-500 hover:text-primary cursor-pointer"
    >
      <ng-icon name="heroXMark" size="24"></ng-icon>
    </button>
    <h2 class="text-2xl font-semibold mb-4 text-center">Verificar compañía</h2>
    <p class="text-md text-gray-700 mb-6 text-center">
      Se envió un código de verificación al correo
      <strong>{{ currentEmail }}</strong
      >.
    </p>
    <form
      [formGroup]="formCode"
      (ngSubmit)="submitCode()"
      class="flex flex-col gap-y-10"
    >
      <div
        formArrayName="code"
        class="flex justify-center gap-2 sm:gap-4 w-full"
      >
        <ng-container *ngFor="let ctrl of codeControls; let i = index">
          <input
            id="code-{{ i }}"
            type="text"
            maxlength="1"
            [formControlName]="i"
            (input)="onInput($event, i)"
            (keydown)="onKeyDown($event, i)"
            class="w-10 h-10 text-center text-xl font-bold border border-gray-300 rounded-md sm:w-14 sm:h-14 sm:text-2xl sm:rounded-xl focus:outline-none focus:ring-2 focus:ring-primary transition"
            style="padding: 0"
          />
        </ng-container>
      </div>
      <div class="text-sm text-gray-600 mb-4 text-center">
        <span *ngIf="!canResend">Reenviar código en {{ countdown }}s</span>
        <a
          *ngIf="canResend"
          (click)="resendCode()"
          class="text-primary hover:underline cursor-pointer"
        >
          Reenviar código
        </a>
      </div>
      <app-loading-button
        [text]="'Confirmar'"
        [loading]="isLoading"
        type="submit"
      ></app-loading-button>
    </form>
  </div>
</div>
